'use client';

import { FC } from 'react';
import { Popup } from './Popup';
import { appButtons } from '@/hotdesk-ui/constants/app-button.constant';
import { useDispatch, useSelector } from 'react-redux';
import { setIsOpen } from '@/hotdesk-ui/store/slices/popup.slice';
import { RootState } from '@/hotdesk-ui/store/store';
export const PopupClientWrapper: FC<{
  language: string;
}> = ({
  language
}) => {
  const moveToExternalLink = async (link?: string, eventName?: string, target?: string) => {
    if (!!eventName) {
      // await this.firebaseAnalyticsServiceRef.logEvent(eventName, {
      //     ...(!!this.source && { source: this.source })
      // });
    }
    if (!!link) {
      if (!!target) {
        window.open(link, target);
      } else {
        window.location.href = link;
      }
    }
  };
  const isOpen = useSelector((state: RootState) => state.popup.isOpen);
  const dispatch = useDispatch();
  return <Popup show={isOpen} handleClose={() => {
    dispatch(setIsOpen(false));
  }} appButtons={appButtons} moveToExternalLink={moveToExternalLink} language={language} data-sentry-element="Popup" data-sentry-component="PopupClientWrapper" data-sentry-source-file="PopupClientWrapper.tsx" />;
};